import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: inline-flex;

  svg {
    color: #64dd17;

    circle {
      stroke-width: 4;
    }
  }
`;

const Percent = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #ed7117;
  font-size: 12px;
  font-weight: bold;
`;

export { Container, Percent };
